import React from 'react';
import { Box, Button, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { INK, MOBILE, YELLOW } from '../constants';

/** Ink quiz callout (Fi Yellow reserved for this CTA). */
export const QuizCta: React.FC<{ onLaunch: () => void }> = ({ onLaunch }) => {
  const { t } = useTranslation();
  return (
    <Stack
      align="center"
      spacing={14}
      bg={INK}
      c="#fff"
      ta="center"
      sx={{
        marginTop: 40,
        borderRadius: 16,
        padding: '56px 32px',
        [MOBILE]: { marginTop: 32, padding: '40px 20px' },
      }}
    >
      <Box component="span" fw={700} c={YELLOW} tt="uppercase" lts="0.72px" sx={{ fontSize: 12 }}>
        {t('compare_v2_quiz_eyebrow')}
      </Box>
      <Box component="h2" m={0} fw={700} lts="-0.02em" sx={{ fontSize: 'clamp(28px, 5vw, 44px)', lineHeight: 1 }}>
        {t('compare_v2_quiz_title')}
      </Box>
      <Text c="rgba(255, 255, 255, 0.72)" maw={460} lh={1.5} sx={{ fontSize: 17, [MOBILE]: { fontSize: 16 } }}>
        {t('compare_v2_quiz_subtitle')}
      </Text>
      <Button
        color="fi-yellow"
        radius={999}
        mt={8}
        onClick={onLaunch}
        styles={{
          root: { height: 'auto', padding: '16px 42px' },
          label: { color: INK, fontSize: 15, fontWeight: 700, letterSpacing: '-0.14px' },
        }}
      >
        {t('compare_v2_quiz_cta')}
      </Button>
    </Stack>
  );
};
